module.exports = __webpack_public_path__ + "static/media/a.opt.28b53227.jpg";